export { ghostPrimaryStyle } from "./ghost/primary";
export { ghostStrokeStyle } from "./ghost/stroke";
export { ghostFilledStyle } from "./ghost/filled";
export { ghostTextStyle } from "./ghost/text";
export { ghostLinkStyle } from "./ghost/link";
export { basicPrimaryStyle } from "./basic/primary";
export { basicStrokeStyle } from "./basic/stroke";
export { basicFilledStyle } from "./basic/filled";
export { basicTextStyle } from "./basic/text";
export { basicLinkStyle } from "./basic/link";
